import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { getTokenUser, getUserCommercialLink } from 'domains/user';
import { Box, Flex, Image, Text, WithTooltip } from 'UI';

const SFlex = styled(Flex)`
  padding: 0 20px 0 20px;
`;

export const TextWrapper = styled(Flex)`
  overflow: hidden;
`;

export const getRandomAvatar = () =>
  `avatars/profile_${(window.crypto.getRandomValues(new Uint8Array(1))[0] % 8) + 1}.png`;

// Module-level cache so every consumer (ProfileInfo, ProfileCard, ...) shows the same
// avatar for the current user without lifting state into Redux/context.
let cachedAvatarUserId: string | undefined;
let cachedAvatarSrc: string | undefined;

export const getAvatar = (userId?: string) => {
  if (cachedAvatarUserId !== userId || !cachedAvatarSrc) {
    cachedAvatarUserId = userId;
    cachedAvatarSrc = getRandomAvatar();
  }
  return cachedAvatarSrc;
};

const ProfileInfo = ({ mini }: { mini: boolean }) => {
  const userInfo = useSelector(getTokenUser);
  const commercialLink = useSelector(getUserCommercialLink);
  const [avatar, setAvatar] = useState(() => getAvatar(userInfo?.id));
  const height = 70;
  const width = mini ? 90 : 250;

  useEffect(() => {
    setAvatar(getAvatar(userInfo?.id));
  }, [userInfo?.id]);

  return (
    <SFlex
      maxHeight={height}
      minHeight={height}
      justify={mini ? 'center' : 'flex-start'}
      align={'center'}
      minWidth={width}
      maxWidth={width}
      gap={12}
    >
      <Box width={44}>
        <Image alt={'avatar'} src={avatar} width={44} />
      </Box>
      {!mini && (
        <TextWrapper direction={'column'}>
          <WithTooltip title={commercialLink?.name ?? ''} placement={'right'}>
            <Text type={'light_10_black_65'} noWrap ellipsis>
              {commercialLink?.name ?? ''}
            </Text>
          </WithTooltip>
          <Text type="base">{userInfo?.id ?? ''}</Text>
        </TextWrapper>
      )}
    </SFlex>
  );
};

export default ProfileInfo;
